import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Invoice {
    id: number;
    uuid: string;
    invoice_number: string,
    pi_id: number,
    pi_no: string,
    consignee: string,
    consignee_email: string,
    consignee_id: number,
    status: string,
    amount: number,
    amount_due: number,
    conversion_rate: number,
    amount_rs: number,
    country: string,
    port: string,
    contract_no: string,
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
}

interface InvoiceState {
    invoice: Invoice | null;  
    loading: boolean;
    error: string | null;
}

const initialState: InvoiceState = {
    invoice: null,  
    loading: false,
    error: null,
};

const activeInvoiceSlice = createSlice({
    name: 'activeInvoice',
    initialState,
    reducers: {
        setActiveInvoice(state, action: PayloadAction<Invoice>) {
            state.invoice = action.payload;  
        },
        resetActiveInvoice(state) {
            state.invoice = null; 
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;  
        },
        setError(state, action: PayloadAction<string | null>) {
            state.error = action.payload;  
        },
    },
});

export const { setActiveInvoice, resetActiveInvoice, setLoading, setError } = activeInvoiceSlice.actions;

export default activeInvoiceSlice.reducer;

export const selectActiveClient = (state: { activeInvoice: InvoiceState }) => state.activeInvoice.invoice;
